import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {BookOfShadowsGameConfig} from "../../../BookOfShadowsGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class BookOfShadowsSymbolIdleAnimationController implements GameRoundPresentation {
    private readonly _hasSymbolIdle: boolean = false;

    /**
     * @constructs
     */
    constructor() {
        this._hasSymbolIdle = (BookOfShadowsGameConfig.instance.SYMBOL_STATES.idle !== undefined);
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: SpinParsedGameData): Timeline | null {
        if ((data.betWins && data.betWins.length > 0)) {
            return null;
        }

        if (!this._hasSymbolIdle) {
            return null;
        }

        const tl: TimelineLite = new TimelineLite(),
            totalRows: number = 5,
            idleSyms: string[] = ["S", "M1", "M2"],
            startDelay: number = MathHelper.randomIntInRange(4, 6);

        let symbol: StateReelSymbol | null,
            reelSet: string[];

        for (let i = 0; i < data.reels.length; i++) {
            reelSet = data.reels[i];
            // Scanning the reels for animation. Restricting the iteration to 1/2/3 to 5 as per active rows out of 0 to 6 in the actual reelSet.
            for (let j = (totalRows - BookOfShadowsGameConfig.instance.ACTIVE_ROWS) + 1; j < reelSet.length - 1; j++) {
                if (idleSyms.indexOf(reelSet[j]) !== -1) {
                    symbol = Reels.getSymbol(i, j - 1)!; // need to subtract 1 from j because findSymbol used symbolOnTop number while finding the symbol.
                    if (symbol && idleSyms.indexOf(symbol.symName) !== -1) {
                        const symbolDelay: number = MathHelper.randomIntInRange(5, 10) / 10;

                        tl.add(this.changeState.bind(this, symbol), (((symbol.symName === "S") ? 0 : startDelay) + symbolDelay));
                    }
                }
            }
        }

        // #295 and in general, if the totalDuration was 0, it must send back null and then will cause troubles in the GameRoundManager.
        if (tl.totalDuration() === 0) {
            tl.add(() => {}, 4); // setting the minimum start delay used in this file.
        }

        return tl;
    }

    /**
     * @description Method in which the actual call is happening.
     * @param symbol
     */
    private changeState(symbol: StateReelSymbol): void {
        symbol.changeState({
            state: BookOfShadowsGameConfig.instance.SYMBOL_STATES.idle,
            fadeInDuration: 0.2
        });
    }
}
